
import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../../_services/api.service';
import { SharedService } from '../../../../_services/shared.service';
import { PaginationComponent } from '../../../_common/pagination/pagination.component';
import { DropdownComponent } from '../../../_common/dropdown/dropdown.component';
import { IDropdown, DropdownSize } from '../../../../_interfaces/packageList';
import { MessageType } from '../../../../_interfaces/entity';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-accuracy-report',
  standalone: true,
  imports: [CommonModule, FormsModule, PaginationComponent, DropdownComponent],
  providers: [DatePipe],
  templateUrl: './accuracy-report.component.html',
  styleUrl: './accuracy-report.component.scss',
})
export class AccuracyReportComponent {
  @Input() coderNameList: string[] = [];
  @Input() selectedCase: IDropdown = { id: '', value: '' };
  monthsList: any[] = [];
  selectedDate: string = '';
  selectedMonth: any = '';
  tempSelectedDate: string = '';
  tempSelectedMonth: any = '';
  tempSelectedUser: string = '';

  isMonthly: boolean = true;
  selectedUser: string = '';
  apiService = inject(ApiService);
  sharedService = inject(SharedService);
  reportData: any[] = [];
  datePipe = inject(DatePipe);
  totalRecords: number = 0;
  pageNumber: any = 0;
  pageSize: number = 20;
  currentdate: Date = new Date();
  maxDate: String = this.currentdate.toISOString().split('T')[0];
  dropdownSize = DropdownSize.Medium;

  ngOnInit() {
    this.populateMonthsList();
    this.loadAllData();
    this.angeionDataStorage();
    if (this.sharedService.caseNames().length == 0) this.getCaseNames();
  }

  angeionDataStorage() {
    const sources = localStorage.getItem('sources');
    if (sources) {
      const uniqueCols = JSON.parse(sources).angeionData_archive?.unique_columns;
      if (uniqueCols) {
        this.coderNameList = uniqueCols['User Name'];
      }
    }
  }

  loadAllData() {
    this.sharedService.dashboardSessionStored.set(false);
    this.sharedService.showLoading();
    const data = {
      sourceSet: ['angeionData_archive'],
      client_id: 'Angieon_uuid',
    };
    const baseUrl = environment.baseUrlDashboard;
    this.apiService.dashboardPost(baseUrl + '/sourceApi/load_multiple_data', data).subscribe({
      next: (data) => {
        this.sharedService.hideLoading();
      },
      error: (err) => {
        console.error('Error fetching data', err);
        this.sharedService.hideLoading();
      },
      complete: () => {
        this.sharedService.hideLoading();
      },
    });
  }

  getCaseNames() {
    this.sharedService.showLoading();
    this.apiService.get('user/cases').subscribe({
      next: (response) => {
        this.sharedService.hideLoading();
        if (response?.success == 'true') {
          const caseNames = response.data.map((item: any) => ({ id: item.id, value: item.value }));
          if (caseNames.length == 1 && this.selectedCase.id == '') {
            this.selectedCase = caseNames[0];
          }
          this.sharedService.caseNames.set(caseNames);
        }
      },
      error: (err) => {
        this.sharedService.hideLoading();
        this.sharedService.showToastMessage({
          message: err.message || 'Error',
          type: MessageType.error,
        });
      },
      complete: () => {},
    });
  }

  saveCase(caseName: IDropdown) {
    if (caseName) {
      this.selectedCase = caseName;
    }
  }

  populateMonthsList() {
    const currentDate = new Date();
    for (let i = 0; i < 3; i++) {
      const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
      const endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - i + 1, 0);
      this.monthsList.push({
        startDate: this.datePipe.transform(startDate, 'yyyy-MM-dd'),
        endDate: this.datePipe.transform(endDate, 'yyyy-MM-dd'),
        month: this.datePipe.transform(startDate, 'MMMM yyyy'),
      });
    }
  }

  applyAccuracyReportFilter(pageNumber: number = 0) {
    if (!this.tempSelectedMonth && !this.tempSelectedDate) {
      return;
    }
    this.selectedMonth = this.tempSelectedMonth;
    this.selectedDate = this.tempSelectedDate;
    this.pageNumber = pageNumber;
    this.sharedService.showLoading();
    const queryParams = `coderName=${this.selectedUser}&startDate=${this.isMonthly ? this.selectedMonth.startDate : this.selectedDate}&endDate=${this.isMonthly ? this.selectedMonth.endDate : this.selectedDate}&pageSize=${this.pageSize}&startIndex=${this.pageNumber}&caseId=${this.selectedCase.id}&caseName=${this.selectedCase.value}&sortBy=updatedDate&sortOrder=DESC`;
    this.apiService.get('package/report/classification-stats?' + queryParams).subscribe({
    next: (response) => {
  if (response && response.data && Array.isArray(response.data.data)) {
    this.reportData = response.data.data; // <-- take the nested array
    this.totalRecords = response.data.data.length;
  } else {
    this.reportData = [];
    this.totalRecords = 0;
  }
  },
      error: (err) => {
        this.sharedService.showToastMessage({
          message: err.message || 'Error',
          type: MessageType.error,
        });
        this.sharedService.hideLoading();
      },
      complete: () => {
        this.sharedService.hideLoading();
      },
    });
  }

  resetAccuracyReportFilter() {
    this.selectedCase.value = '';
    this.selectedCase.id = '';
    this.selectedUser = '';
    this.tempSelectedDate = '';
    this.tempSelectedMonth = '';
    this.reportData = [];
  }

  paginationNavigation(pageno: any) {
    this.applyAccuracyReportFilter(pageno - 1);
  }

  validateDate() {
    const today = new Date().toISOString().split('T')[0];
    if (this.selectedDate > today) {
      this.sharedService.showToastMessage({
        message: 'Future dates are not allowed!',
        type: MessageType.error,
      });
      this.selectedDate = '';
    }
  }
}
